import { Dropdown } from "react-bootstrap";
import { useLocalSampleSummaryParams } from "../../../../hooks";
import { PDF_ACTION_TXT } from "../../consts";
import { usePdf } from "../../hooks";

const PdfItem = () => {
  const { hash, sourceId, relationshipId } = useLocalSampleSummaryParams();
  const { status, downloadPdf, makePdf } = usePdf(
    hash,
    sourceId,
    relationshipId
  );

  const handlePdfAction = () => {
    if (status === "download") {
      downloadPdf();
    } else if (status === "make") {
      makePdf();
    }
  };

  return (
    <Dropdown.Item
      onClick={handlePdfAction}
      disabled={status === "wait"}
      data-testid="report_summary_action_pdf"
    >
      {PDF_ACTION_TXT.button[status]}
    </Dropdown.Item>
  );
};

export default PdfItem;
